import { render, staticRenderFns } from "./RecordCostUnitBasedata.vue?vue&type=template&id=be9924f2"
import script from "./RecordCostUnitBasedata.vue?vue&type=script&lang=js"
export * from "./RecordCostUnitBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports